<template>
  <div class="summary">
    <div class="item">
      <div class="text evidence">
        {{ $t('amount') }} {{ $t('all') }} {{ getSettings.currencySymbol }}
      </div>
      <div class="value">
        <input
          autocomplete="off"
          v-model.number="amountSystemEqual"
          type="number"
          step="0.50"
        />
      </div>
    </div>
    <div class="item">
      <div class="text evidence">
        {{ $t('amount') }} {{ $t('divide') }} {{ getSettings.currencySymbol }}
      </div>
      <div class="value">
        <input
          v-model.number="amountSystemToDivide"
          type="number"
          step="0.50"
        />
      </div>
    </div>
    <div class="item-combo header">
      <div class="field check">
        <v-checkbox
          dense
          v-model="checkedAll"
          :disabled="getBet._system_detail.valid_combinations_all == 0"
          @change="checkAllComboSystem()"
        ></v-checkbox>
      </div>
      <div class="field multiplicity">
        <span>{{ $t('type') }}</span>
      </div>
      <div class="field numCombo">
        <span>N°</span>
      </div>
      <div class="field value">
        <span>{{ $t('amount') }}</span>
      </div>
    </div>
    <div
      class="item-combo"
      v-for="(combo, index) in getBetSystemParts"
      :key="'sys_' + index"
      v-if="combo.valid_combinations > 0"
    >
      <div class="field check">
        <v-checkbox
          dense
          :disabled="combo.valid_combinations == 0"
          v-model="combo.checked"
          @change="refreshSystemCart()"
        ></v-checkbox>
      </div>
      <div class="field multiplicity">
        <span
          ><v-icon
            dense
            @click="showDetailCombo(combo)"
            v-if="combo.checked && combo.amount > 0"
            >mdi-magnify-plus</v-icon
          ></span
        >
        <span v-if="combo.multiplicity <= 5">
          {{ $t('multi-' + combo.multiplicity) }}
        </span>
        <span v-else> {{ combo.multiplicity }}{{ $t('-multi') }} </span>
      </div>
      <div class="field numCombo">
        <span>{{ combo.valid_combinations }}</span>
      </div>
      <div class="field value">
        <!-- this version lose the focus on a single input !!! -->
        <!--        <input :disabled="(combo.valid_combinations == 0)" v-model.number="combo.amount" type="number"-->
        <!--               step="0.50" @change="refreshSystemCart(combo)" @input="refreshSystemCart(combo)"/>-->

        <!-- this version works but at the moment i prefer use the version with debounce function that after 300 ms lose focus on input and update the model -->
        <!--        <input-->
        <!--                :disabled="(combo.valid_combinations == 0)"-->
        <!--                v-model.number="combo.amount"-->
        <!--                type="number"-->
        <!--                step="0.50"-->
        <!--                @blur="handleBlur(combo, index)"-->
        <!--                :ref="'amountInput' + index"-->
        <!--        />-->

        <input
          :disabled="combo.valid_combinations == 0"
          v-model.number="combo.amount"
          type="number"
          step="0.50"
          @change="refreshSystemCart(combo)"
        />
      </div>
      <div class="break-flex"></div>
      <div
        class="detail-system"
        v-if="combo.checked && combo.amount > 0 && combo.show"
      >
        <div class="item-detail">
          {{ $t('amount')
          }}<span class="font-weight-bold"
            >{{ getSettings.currencySymbol
            }}{{ combo.totalAmount | round_digits(2) }}</span
          >
        </div>
        <div class="item-detail">
          {{ $t('win') }} {{ $t('min')
          }}<span class="font-weight-bold"
            >{{ getSettings.currencySymbol
            }}{{ combo.winning_min | round_digits(2) }}</span
          >
        </div>
        <div class="item-detail">
          {{ $t('win') }} {{ $t('max')
          }}<span class="font-weight-bold"
            >{{ getSettings.currencySymbol
            }}{{ combo.winning_all | round_digits(2) }}</span
          >
        </div>
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_combinations">
      <div class="text">{{ $t('combinations') }}</div>
      <div class="value">{{ getBet._system_detail.combinations }}</div>
    </div>
    <div class="item" v-if="getSettings.sys_amount_total">
      <div class="text">
        {{ $t('amount') }} {{ $t('total') }} {{ $t('system') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.amount_system) }}
      </div>
    </div>

    <div
      class="item"
      v-if="getSettings.sys_bonus_min && +getBet._system_detail.bonus_min > 0"
    >
      <div class="text">{{ $t('bonus') }} {{ $t('min') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.bonus_min) }}
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_winning_min">
      <div class="text">{{ $t('winning') }} {{ $t('min') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.winning_min) }}
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_winning_total_min">
      <div class="text">
        {{ $t('winning') }} {{ $t('total') }} {{ $t('min') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.winning_total_min) }}
      </div>
    </div>

    <div
      class="item"
      v-if="getSettings.sys_bonus_max && +getBet._system_detail.bonus_max > 0"
    >
      <div class="text">{{ $t('bonus') }} {{ $t('max') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.bonus_max) }}
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_winning_max">
      <div class="text">{{ $t('winning') }} {{ $t('max') }}</div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.winning_max) }}
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_winning_total_max">
      <div class="text">
        {{ $t('winning') }} {{ $t('total') }} {{ $t('max') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.winning_total_max) }}
      </div>
    </div>

    <div class="item" v-if="getSettings.sys_winning_all_total">
      <div class="text">
        {{ $t('winning') }} {{ $t('all') }} {{ $t('total') }}
      </div>
      <div class="value">
        {{ getSettings.currencySymbol }}
        {{ formatNumber(getBet._system_detail.winning_all_total) }}
      </div>
    </div>

    <template v-if="getPercentageTaxValueOnWon > 0">
      <div class="item">
        <div class="text">{{ $t('percentageTaxValueOnWon') }}</div>
        <div class="value">{{ getPercentageTaxValueOnWon + ' %' }}</div>
      </div>

      <div class="item">
        <div class="text">{{ $t('winning_total_min_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._system_detail.winning_total_min_taxed) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('winning_total_max_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._system_detail.winning_total_max_taxed) }}
        </div>
      </div>

      <div class="item">
        <div class="text">{{ $t('winning_all_total_taxed') }}</div>
        <div class="value">
          {{ getSettings.currencySymbol }}
          {{ formatNumber(getBet._system_detail.winning_all_total_taxed) }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash/debounce'

export default {
  name: 'SummarySystem',
  data: () => ({
    checkedAll: false,
    //focusedIndex: null,
  }),
  mounted() {
    this.$root.$on('forceUpdateSystem', () => {
      this.setCheckedAll()
      this.forceUpdateSummarySystem()
    })
  },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getBetSystemParts: 'cart/getBetSystemParts',
      getSettings: 'cart/getSettings',
      getPercentageTaxValueOnWon: 'settings/getPercentageTaxValueOnWon',
    }),

    amountSystemEqual: {
      get() {
        return this.$store.state.cart.bet._system_detail.amount_system_equal
      },
      async set(value) {
        const amount =
          value >= 0 ? value : this.$store.state.cart.settings.minAmount
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_TO_DIVIDE', null)
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_EQUAL', amount)
        await this.$store.dispatch('cart/refreshCart')
        this.forceUpdateSummarySystem()
      },
    },
    amountSystemToDivide: {
      get() {
        return this.$store.state.cart.bet._system_detail.amount_system_to_divide
      },
      async set(value) {
        const amount =
          value >= 0 ? value : this.$store.state.cart.settings.minAmount
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_EQUAL', null)
        await this.$store.commit('cart/SET_SYSTEM_AMOUNT_TO_DIVIDE', amount)
        await this.$store.dispatch('cart/refreshCart')
        this.forceUpdateSummarySystem()
      },
    },
  },
  created() {
    setTimeout(() => {
      this.setCheckedAll()
      this.forceUpdateSummarySystem()
    }, 100)
  },
  methods: {
    ...mapActions({
      refreshCart: 'cart/refreshCart',
      setSystemComboDetail: 'cart/setSystemComboDetail',
      setSystemAmountEqual: 'cart/setSystemAmountEqual',
      setSystemAmountToDivide: 'cart/setSystemAmountToDivide',
      setIsCartUpdating: 'cart/setIsCartUpdating',
    }),

    debounceRefreshSystemCart: debounce(async function (combo) {
      await this.refreshSystemCart(combo)
    }, 450),

    /*handleFocus(index) {
        this.focusedIndex = index;
      },*/

    formatNumber(amount) {
      const numberFormatted = new Intl.NumberFormat().format(amount)

      return numberFormatted
    },

    forceUpdateSummarySystem() {
      this.$forceUpdate()
    },

    /* async handleBlur(combo, index) {
         // Call refreshSystemCart when input loses focus
         await this.refreshSystemCart(combo);

         // Check if the current input is still the focused one
         if (this.focusedIndex === index) {
           // Returns focus to the specific input after the next render cycle
           this.$nextTick(() => {
             this.$refs['amountInput' + index][0].focus();
           });
         }
       },*/

    async refreshSystemCart(combo = undefined) {
      const vue = this

      await this.setIsCartUpdating(true)

      try {
        if (combo != undefined) {
          this.getBet._system_detail.amount_system_equal = null
          this.getBet._system_detail.amount_system_to_divide = null

          if (combo.amount > 0.0) {
            combo.checked = true
          } else {
            combo.checked = false
          }
        }
        this.setCheckedAll()
        await this.setSystemComboDetail({
          system_parts: this.getBet.system_parts,
        })
        await this.refreshCart()
        this.forceUpdateSummarySystem()
      } finally {
        await vue.setIsCartUpdating(false)
      }
    },

    async checkAllComboSystem() {
      if (this.checkedAll) {
        _.forEach(this.getBet.system_parts, detail => {
          if (detail != undefined && detail.valid_combinations > 0) {
            detail.checked = true
          }
        })
      } else {
        _.forEach(this.getBet.system_parts, detail => {
          if (detail != undefined) {
            detail.checked = false
          }
        })
      }

      await this.refreshSystemCart()
    },

    setCheckedAll() {
      const vue = this
      const not_checked = _.filter(vue.getBet.system_parts, function (o) {
        if (o.checked == false && o.valid_combinations > 0) {
          return o
        }
      })
      if (
        not_checked == undefined ||
        not_checked.length >= 1 ||
        vue.getBet._system_detail.valid_combinations_all == 0
      ) {
        vue.checkedAll = false
      } else {
        vue.checkedAll = true
      }
    },

    showDetailCombo(combo) {
      combo.show = !combo.show
    },
  },
}
</script>
